import { useState, useEffect } from "react";

export function DocumentView({ document }) {
  const [isOpen, setIsOpen] = useState(false);
  const [blobUrl, setBlobUrl] = useState("");

  useEffect(() => {
    if (!document) return;

    const supportedDocs = [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (supportedDocs.includes(document.mimeType)) {
      // Convert base64 to Blob URL for Office preview
      const byteCharacters = atob(document.fileBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: document.mimeType });
      setBlobUrl(URL.createObjectURL(blob));
    }
  }, [document]);

  if (!document)
    return <p className="text-gray-500 italic">No document uploaded.</p>;

  return (
    <div className="border p-3 rounded bg-gray-50">
      <p className="font-semibold text-primary-600">Uploaded Document:</p>
      <button
        onClick={() => setIsOpen(true)}
        className="text-primary-600 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
        type="button"
      >
        {document.fileName || "View Document"}
      </button>

      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="bg-white p-4 w-full md:w-2/3 lg:w-1/2 rounded-lg shadow-md relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-2 right-3 text-gray-600 hover:text-gray-900 font-bold text-2xl"
              aria-label="Close modal"
              type="button"
            >
              &times;
            </button>

            {document.mimeType.startsWith("application/pdf") ? (
              <iframe
                src={`data:${document.mimeType};base64,${document.fileBase64}`}
                title={document.fileName}
                width="100%"
                height="500px"
                className="border"
              />
            ) : document.mimeType.startsWith("image/") ? (
              <img
                src={`data:${document.mimeType};base64,${document.fileBase64}`}
                alt={document.fileName}
                className="w-full h-auto border rounded"
              />
            ) : blobUrl ? (
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                  blobUrl
                )}`}
                title={document.fileName}
                width="100%"
                height="500px"
                className="border"
              />
            ) : (
              <p className="text-red-500">Unsupported file type.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
